export { GlobalFooter } from './GlobalFooter'
